module.exports = __webpack_public_path__ + "img/map_courses_active.f06900e8.svg";